import React, { Fragment } from 'react'
import { NavLink } from 'react-router-dom'
import { Icon } from '@material-ui/core'
import TouchRipple from '@material-ui/core/ButtonBase'
import MatxVerticalNavExpansionPanel from './MatxVerticalNavExpansionPanel'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import useSettings from 'app/hooks/useSettings'
import { Padding } from '@mui/icons-material'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    navItem: {
        transition: 'all 150ms ease-in',
        '&:hover': {
            // backgroundColor: palette.action.hover,
            //backgroundColor: "#06a8d4" 
            background: `linear-gradient(86deg,  #ffffff,${palette.sideNav.primary.main})`
        },
    },
    navItemActive: {
        // backgroundColor: palette.action.selected,
        //backgroundColor: "#06a8d4",
        background: `linear-gradient(86deg, #ffffff, ${palette.sideNav.primary.main})`,
        boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)', // ← this adds a soft shadow
        border: 'none',
        '& button': {
            // backgroundColor: palette.action.hover,
            fontWeight: "bold",
            color: palette.sideNav.primary.contrastTextActive,

        },
        '& .menuIcon': {
            color: palette.sideNav.sideNavIcon.activeColor,
            // border:'1px solid black',
            borderRadius:'10px',
            background:'#24AB70',
            padding: '10px',
            marginRight:'3px',

            display: 'inline-flex',        // ensures icon keeps its original size
            alignItems: 'center',
            justifyContent: 'center',
        
            fontSize: '24px !important',              // or whatever size you need
            width: 'auto ',                 // let it grow with padding
            height: 'auto ',
        },
        '& $itemText': {
            color: palette.sideNav.primary.contrastTextActive,
        },

    },
    compactNavItem: {
        overflow: 'hidden',
        fontFamily: theme.typography.fontFamily,
        justifyContent: 'center !important',
        '& $itemText': {
            display: 'none',
        },
        '& $itemIcon': {
            display: 'none',
        },
    },
    itemIcon: {},
    itemText: {
        fontSize: '14px',
        //paddingLeft: '0.8rem',
        paddingTop: '2px !important',
        fontFamily: theme.typography.fontFamily,
        color: palette.sideNav.primary.contrastText,
       // fontWeight: "bold",
    },
    label: {
        color: palette.sideNav.primary.contrastText,
        fontFamily: theme.typography.fontFamily,
    },
    bulletIcon: {
        background: palette.sideNav.sideNavIcon.main,
    },
    menuIcon: {
        color: palette.sideNav.sideNavIcon.main,
        borderRadius: '10px',
        background: `linear-gradient(86deg, #ffffff, ${palette.sideNav.primary.main})`,
        boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)',
        padding: '10px',
        marginRight:'7px',
        display: 'inline-flex',        // ensures icon keeps its original size
        alignItems: 'center',
        justifyContent: 'center',
    
        fontSize: '24px !important',              // or whatever size you need
        width: 'auto !important',                 // let it grow with padding
        height: 'auto !important',                // avoid forced shrinking
    }    
}))

const MatxVerticalNav = ({ items }) => {
    const { settings } = useSettings()
    const { mode } = settings.layout1Settings.leftSidebar
    const classes = useStyles()

    const renderLevels = (data) => {
        return data.map((item, index) => {
            if (item.type === 'label')
                return (
                    <p
                        key={index}
                        className={clsx({
                            'px-4 mb-2 mt-6 uppercase text-12 sidenavHoverShow': true,
                            [classes.label]: true,
                            hidden: mode === 'compact',
                        })}
                    >
                        {item.label}
                    </p>
                )
            if (item.children) {
                return (
                    <MatxVerticalNavExpansionPanel
                        mode={mode}
                        item={item}
                        key={index}
                    >
                        {renderLevels(item.children)}
                    </MatxVerticalNavExpansionPanel>
                )
            } else if (item.type === 'extLink') {
                return (
                    <a
                        key={index}
                        href={item.path}
                        className={clsx({
                            'flex justify-between h-60 border-radius-4 mb-2 compactNavItem whitespace-pre overflow-hidden nav-item-custom': true,
                            [classes.navItem]: true,
                            [classes.compactNavItem]: mode === 'compact', 
                        })}v
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <TouchRipple
                            key={item.name}
                            name="child"
                            className="w-full"
                        >
                            {(() => {
                                if (item.icon) {
                                    return (
                                        <div className='pl-1'>
                                            {React.cloneElement(item.icon, { className: clsx({ 'text-25 align-middle w-40 menuIcon': true, [classes.menuIcon]: true }) })}
                                        </div>
                                    )
                                } else {
                                    return (
                                        <span className="item-icon icon-text">
                                            {item.iconText}
                                        </span>
                                    )
                                }
                            })()}
                            <span
                                className={clsx(
                                    'align-middle sidenavHoverShow',
                                    classes.itemText
                                )}
                            >
                                {item.name}
                            </span>
                            <div className="mx-auto"></div>
                            {item.badge && (
                                <div
                                    className={`rounded bg-${item.badge.color} px-1 py-1px`}
                                >
                                    {item.badge.value}
                                </div>
                            )}
                        </TouchRipple>
                    </a>
                )
            } else {
                return (
                    <NavLink
                        key={index}
                        to={item.path}
                        activeClassName={classes.navItemActive}
                        className={clsx({
                            'flex justify-between h-60 pt-5 pb-5 border-radius-12  mb-2 shadow-md bg-white compactNavItem whitespace-pre overflow-hidden nav-item-custom': true,
                            [classes.navItem]: true,
                            [classes.compactNavItem]: mode === 'compact',
                        })}
                    >
                        <TouchRipple
                            key={item.name}
                            name="child"
                            className="w-full"
                        >

                            {item?.icon ? (
                                <div className='pl-1'>
                                    {React.cloneElement(item.icon, { className: clsx({ 'text-25 align-middle w-40 menuIcon': true, [classes.menuIcon]: true }) })}
                                </div>
                            )
                                : (
                                    <Fragment>
                                        <div
                                            className={clsx({
                                                'nav-bullet p-2px rounded ml-6 mr-2': true,
                                                /*  [classes.bulletIcon]: true, */
                                                hidden: mode === 'compact',
                                            })}
                                        ></div>
                                        <div
                                            className={clsx({
                                                'nav-bullet-text ml-2 text-12': true,
                                                hidden: mode !== 'compact',
                                            })}
                                        >
                                            {item.iconText}
                                        </div>
                                    </Fragment>
                                )}
                            <span

                                className={clsx({
                                    'align-middle text-left sidenavHoverShow': true,
                                    [classes.itemText]: true
                                }
                                )}
                            >
                                {item.name}
                            </span>
                            <div className="mx-auto"></div>
                            {item.badge && (
                                <div
                                    className={clsx(
                                        `rounded bg-${item.badge.color} px-1 py-1px`,
                                        'sidenavHoverShow',
                                        classes.itemIcon
                                    )}
                                >
                                    {item.badge.value}
                                </div>
                            )}
                        </TouchRipple>
                    </NavLink >
                )
            }
        })
    }

    return <div className="navigation">{renderLevels(items)}</div>
}

export default React.memo(MatxVerticalNav)
